import { useSrpContext } from '@/src/contexts'

import HeroSection from './heroSection'

const HeroSectionWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()

    const hero = sections?.hero
    if (!hero?.heading && !hero?.subheading) return null

    return (
        <HeroSection
            heading={hero.heading ?? ''}
            subheading={hero.subheading ?? ''}
        />
    )
}

export default HeroSectionWrapper
